import { __runInitializers, __esDecorate } from 'tslib';
import { element, property, query, dispatch, ready, request, render, styles, html, unsafeHTML, css } from 'snice';

var cssContent = ":host([hidden]){display:none}:host{display:block;width:100%;height:var(--snice-terminal-height,400px);font-family:Monaco,Menlo,'Ubuntu Mono',Consolas,source-code-pro,monospace;font-size:var(--snice-terminal-font-size, .875rem);line-height:var(--snice-terminal-line-height, 1.2);background:var(--snice-terminal-background,#1e1e1e);color:var(--snice-terminal-foreground,#d4d4d4);border-radius:var(--snice-terminal-border-radius,var(--snice-border-radius-md,.25rem));overflow:hidden;box-sizing:border-box}.terminal-container{display:flex;flex-direction:column;height:100%;padding:var(--snice-spacing-md,1rem);overflow:hidden;box-sizing:border-box}.terminal-output{flex:1;overflow-y:auto;overflow-x:hidden;margin-bottom:var(--snice-spacing-xs,.5rem)}.terminal-output::-webkit-scrollbar{width:var(--snice-spacing-xs,.5rem)}.terminal-output::-webkit-scrollbar-track{background:0 0}.terminal-output::-webkit-scrollbar-thumb{background:var(--snice-terminal-scrollbar-color,var(--snice-color-border,rgb(226 226 226)));border-radius:var(--snice-border-radius-sm,.125rem)}.terminal-output::-webkit-scrollbar-thumb:hover{background:var(--snice-terminal-scrollbar-hover-color,var(--snice-color-border-hover,rgb(209 213 219)))}.terminal-line{display:flex;align-items:flex-start;gap:var(--snice-spacing-xs,.5rem);margin:0}.terminal-line.input{color:var(--snice-terminal-input-color,#d4d4d4)}.terminal-line.output{color:var(--snice-terminal-output-color,#d4d4d4)}.terminal-line.error{color:var(--snice-terminal-error-color,#f48771)}.terminal-line.info{color:var(--snice-terminal-info-color,#75beff)}.terminal-line.success{color:var(--snice-terminal-success-color,#89d185)}.terminal-line.warning{color:var(--snice-terminal-warning-color,#dcdcaa)}.line-timestamp{color:var(--snice-terminal-timestamp-color,hsl(0 0% 40%));font-size:var(--snice-font-size-xs, .75rem);flex-shrink:0;min-width:3.75rem}.line-content{flex:1;white-space:pre}.terminal-input-line{display:flex;align-items:center;gap:var(--snice-spacing-xs,.5rem);padding:var(--snice-spacing-sm,.75rem) 0}.terminal-prompt{color:var(--snice-terminal-prompt-color,#89d185);flex-shrink:0;user-select:none}.terminal-input{flex:1;background:0 0;border:none;outline:0;color:var(--snice-terminal-foreground,#d4d4d4);font-family:inherit;font-size:inherit;line-height:inherit;caret-color:var(--snice-terminal-cursor-color,#d4d4d4);padding:0}.terminal-input::selection{background:var(--snice-terminal-selection-color,hsl(210 52% 31% / .6))}@keyframes blink{0%,50%{opacity:1}100%,51%{opacity:0}}.terminal-input:focus-visible{animation:none}.terminal-cursor{display:inline-block;width:8px;height:1.2em;background:var(--snice-terminal-cursor-color,#d4d4d4);animation:1s step-end infinite blink;vertical-align:text-bottom}:host([readonly]) .terminal-input-line{display:none}.ansi-black{color:var(--snice-terminal-ansi-black,#000)}.ansi-red{color:var(--snice-terminal-ansi-red,#cd3131)}.ansi-green{color:var(--snice-terminal-ansi-green,#0dbc79)}.ansi-yellow{color:var(--snice-terminal-ansi-yellow,#e5e510)}.ansi-blue{color:var(--snice-terminal-ansi-blue,#2472c8)}.ansi-magenta{color:var(--snice-terminal-ansi-magenta,#bc3fbc)}.ansi-cyan{color:var(--snice-terminal-ansi-cyan,#11a8cd)}.ansi-white{color:var(--snice-terminal-ansi-white,#e5e5e5)}.ansi-bright-black{color:var(--snice-terminal-ansi-bright-black,#666)}.ansi-bright-red{color:var(--snice-terminal-ansi-bright-red,#f14c4c)}.ansi-bright-green{color:var(--snice-terminal-ansi-bright-green,#23d18b)}.ansi-bright-yellow{color:var(--snice-terminal-ansi-bright-yellow,#f5f543)}.ansi-bright-blue{color:var(--snice-terminal-ansi-bright-blue,#3b8eea)}.ansi-bright-magenta{color:var(--snice-terminal-ansi-bright-magenta,#d670d6)}.ansi-bright-cyan{color:var(--snice-terminal-ansi-bright-cyan,#29b8db)}.ansi-bright-white{color:var(--snice-terminal-ansi-bright-white,#fff)}.ansi-bold{font-weight:var(--snice-font-weight-bold,700)}.ansi-dim{opacity:.7}.ansi-italic{font-style:italic}.ansi-underline{text-decoration:underline}.empty-hint{color:var(--snice-terminal-hint-color,hsl(0 0% 40%));font-style:italic;margin-bottom:8px}@media (prefers-reduced-motion:reduce){*{transition-duration:0s!important;animation-duration:0s!important}}";

let SniceTerminal = (() => {
    let _classDecorators = [element('snice-terminal')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _renderTrigger_decorators;
    let _renderTrigger_initializers = [];
    let _renderTrigger_extraInitializers = [];
    let _prompt_decorators;
    let _prompt_initializers = [];
    let _prompt_extraInitializers = [];
    let _cwd_decorators;
    let _cwd_initializers = [];
    let _cwd_extraInitializers = [];
    let _readonly_decorators;
    let _readonly_initializers = [];
    let _readonly_extraInitializers = [];
    let _maxLines_decorators;
    let _maxLines_initializers = [];
    let _maxLines_extraInitializers = [];
    let _showTimestamps_decorators;
    let _showTimestamps_initializers = [];
    let _showTimestamps_extraInitializers = [];
    let _inputElement_decorators;
    let _inputElement_initializers = [];
    let _inputElement_extraInitializers = [];
    let _outputElement_decorators;
    let _outputElement_initializers = [];
    let _outputElement_extraInitializers = [];
    let _dispatchCommandEvent_decorators;
    let _dispatchClearEvent_decorators;
    let _dispatchReadyEvent_decorators;
    let _onReady_decorators;
    let _executeCommand_decorators;
    let _render_decorators;
    let _styles_decorators;
    (class extends _classSuper {
        static { _classThis = this; }
        constructor() {
            super(...arguments);
            this.lines = (__runInitializers(this, _instanceExtraInitializers), []);
            this.renderTrigger = __runInitializers(this, _renderTrigger_initializers, 0);
            this.prompt = (__runInitializers(this, _renderTrigger_extraInitializers), __runInitializers(this, _prompt_initializers, '$ '));
            this.cwd = (__runInitializers(this, _prompt_extraInitializers), __runInitializers(this, _cwd_initializers, '~'));
            this.readonly = (__runInitializers(this, _cwd_extraInitializers), __runInitializers(this, _readonly_initializers, false));
            this.maxLines = (__runInitializers(this, _readonly_extraInitializers), __runInitializers(this, _maxLines_initializers, 1000));
            this.showTimestamps = (__runInitializers(this, _maxLines_extraInitializers), __runInitializers(this, _showTimestamps_initializers, false));
            this.inputElement = (__runInitializers(this, _showTimestamps_extraInitializers), __runInitializers(this, _inputElement_initializers, void 0));
            this.outputElement = (__runInitializers(this, _inputElement_extraInitializers), __runInitializers(this, _outputElement_initializers, void 0));
            this.commandHistory = (__runInitializers(this, _outputElement_extraInitializers), []);
            this.historyIndex = -1;
            this.currentInput = '';
            // ─── Streaming API ─────────────────────────────────────────────────────────
            // appendChunk + pipeFrom let callers feed raw chunks (e.g. from a child
            // process stdout, a WebSocket, or an LLM token stream) without splitting on
            // newlines themselves. A trailing partial line stays "live" — a single
            // TerminalLine whose content grows as more chunks arrive — until a newline
            // commits it.
            this.liveLineBuffer = '';
            this.liveLine = null;
            this.liveLineType = 'output';
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _renderTrigger_decorators = [property({ type: Number })];
            _prompt_decorators = [property()];
            _cwd_decorators = [property()];
            _readonly_decorators = [property({ type: Boolean })];
            _maxLines_decorators = [property({ type: Number, attribute: 'max-lines' })];
            _showTimestamps_decorators = [property({ type: Boolean, attribute: 'show-timestamps' })];
            _inputElement_decorators = [query('.terminal-input')];
            _outputElement_decorators = [query('.terminal-output')];
            _dispatchCommandEvent_decorators = [dispatch('terminal-command', { bubbles: true, composed: true })];
            _dispatchClearEvent_decorators = [dispatch('terminal-clear', { bubbles: true, composed: true })];
            _dispatchReadyEvent_decorators = [dispatch('terminal-ready', { bubbles: true, composed: true })];
            _onReady_decorators = [ready()];
            _executeCommand_decorators = [request('terminal-command')];
            _render_decorators = [render()];
            _styles_decorators = [styles()];
            __esDecorate(this, null, _dispatchCommandEvent_decorators, { kind: "method", name: "dispatchCommandEvent", static: false, private: false, access: { has: obj => "dispatchCommandEvent" in obj, get: obj => obj.dispatchCommandEvent }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _dispatchClearEvent_decorators, { kind: "method", name: "dispatchClearEvent", static: false, private: false, access: { has: obj => "dispatchClearEvent" in obj, get: obj => obj.dispatchClearEvent }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _dispatchReadyEvent_decorators, { kind: "method", name: "dispatchReadyEvent", static: false, private: false, access: { has: obj => "dispatchReadyEvent" in obj, get: obj => obj.dispatchReadyEvent }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _onReady_decorators, { kind: "method", name: "onReady", static: false, private: false, access: { has: obj => "onReady" in obj, get: obj => obj.onReady }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _executeCommand_decorators, { kind: "method", name: "executeCommand", static: false, private: false, access: { has: obj => "executeCommand" in obj, get: obj => obj.executeCommand }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _render_decorators, { kind: "method", name: "render", static: false, private: false, access: { has: obj => "render" in obj, get: obj => obj.render }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _styles_decorators, { kind: "method", name: "styles", static: false, private: false, access: { has: obj => "styles" in obj, get: obj => obj.styles }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(null, null, _renderTrigger_decorators, { kind: "field", name: "renderTrigger", static: false, private: false, access: { has: obj => "renderTrigger" in obj, get: obj => obj.renderTrigger, set: (obj, value) => { obj.renderTrigger = value; } }, metadata: _metadata }, _renderTrigger_initializers, _renderTrigger_extraInitializers);
            __esDecorate(null, null, _prompt_decorators, { kind: "field", name: "prompt", static: false, private: false, access: { has: obj => "prompt" in obj, get: obj => obj.prompt, set: (obj, value) => { obj.prompt = value; } }, metadata: _metadata }, _prompt_initializers, _prompt_extraInitializers);
            __esDecorate(null, null, _cwd_decorators, { kind: "field", name: "cwd", static: false, private: false, access: { has: obj => "cwd" in obj, get: obj => obj.cwd, set: (obj, value) => { obj.cwd = value; } }, metadata: _metadata }, _cwd_initializers, _cwd_extraInitializers);
            __esDecorate(null, null, _readonly_decorators, { kind: "field", name: "readonly", static: false, private: false, access: { has: obj => "readonly" in obj, get: obj => obj.readonly, set: (obj, value) => { obj.readonly = value; } }, metadata: _metadata }, _readonly_initializers, _readonly_extraInitializers);
            __esDecorate(null, null, _maxLines_decorators, { kind: "field", name: "maxLines", static: false, private: false, access: { has: obj => "maxLines" in obj, get: obj => obj.maxLines, set: (obj, value) => { obj.maxLines = value; } }, metadata: _metadata }, _maxLines_initializers, _maxLines_extraInitializers);
            __esDecorate(null, null, _showTimestamps_decorators, { kind: "field", name: "showTimestamps", static: false, private: false, access: { has: obj => "showTimestamps" in obj, get: obj => obj.showTimestamps, set: (obj, value) => { obj.showTimestamps = value; } }, metadata: _metadata }, _showTimestamps_initializers, _showTimestamps_extraInitializers);
            __esDecorate(null, null, _inputElement_decorators, { kind: "field", name: "inputElement", static: false, private: false, access: { has: obj => "inputElement" in obj, get: obj => obj.inputElement, set: (obj, value) => { obj.inputElement = value; } }, metadata: _metadata }, _inputElement_initializers, _inputElement_extraInitializers);
            __esDecorate(null, null, _outputElement_decorators, { kind: "field", name: "outputElement", static: false, private: false, access: { has: obj => "outputElement" in obj, get: obj => obj.outputElement, set: (obj, value) => { obj.outputElement = value; } }, metadata: _metadata }, _outputElement_initializers, _outputElement_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        dispatchCommandEvent(command, args) {
            return { command, args };
        }
        dispatchClearEvent() {
            return {};
        }
        dispatchReadyEvent() {
            return {};
        }
        onReady() {
            this.dispatchReadyEvent();
        }
        async *executeCommand(commandLine) {
            const parts = commandLine.trim().split(/\s+/);
            const command = parts[0];
            const args = parts.slice(1);
            const payload = {
                command,
                args,
                cwd: this.cwd,
                history: [...this.commandHistory]
            };
            try {
                const response = await (yield payload);
                return response;
            }
            catch (error) {
                // No handler found or error occurred
                console.error('[Terminal] Command execution error:', error);
                return {
                    error: error instanceof Error ? error.message : `Command not found: ${command}`,
                    exitCode: 127
                };
            }
        }
        updateLines() {
            // Limit lines if needed — splice in place rather than slice()/reassign so
            // we don't allocate a fresh array per write under high-frequency streaming.
            const overflow = this.lines.length - this.maxLines;
            if (overflow > 0) {
                this.lines.splice(0, overflow);
            }
            // Trigger re-render by updating a tracked property
            this.renderTrigger++;
            // Scroll to bottom
            requestAnimationFrame(() => {
                if (this.outputElement) {
                    this.outputElement.scrollTop = this.outputElement.scrollHeight;
                }
            });
        }
        render() {
            return html /*html*/ `
      <div class="terminal-container" part="base container" @click="${() => this.handleContainerClick()}">
        <div class="terminal-output" part="output" role="log" aria-live="polite" aria-atomic="false">
          ${this.lines.map(line => this.renderLine(line))}
        </div>

        <if ${!this.readonly}>
          <div class="terminal-input-line" part="input-line">
            <span class="terminal-prompt" part="prompt">${this.prompt}</span>
            <input
              type="text"
              class="terminal-input"
              part="input"
              aria-label="Terminal command"
              @keydown="${(e) => this.handleKeyDown(e)}"
              autocomplete="off"
              spellcheck="false"
            />
          </div>
        </if>
      </div>
    `;
        }
        handleContainerClick() {
            if (!this.readonly) {
                this.focus();
            }
        }
        renderLine(line) {
            const timestamp = this.showTimestamps
                ? line.timestamp.toLocaleTimeString('en-US', { hour12: false })
                : '';
            return html /*html*/ `
      <div class="terminal-line ${line.type}" part="line${({ input: ' line-input', output: ' line-output', error: ' line-error', info: ' line-info', success: ' line-success', warning: ' line-warning' })[line.type] || ''}" data-type="${line.type}">
        <if ${this.showTimestamps}>
          <span class="line-timestamp" part="timestamp">${timestamp}</span>
        </if>
        <span class="line-content" part="line-content">${unsafeHTML(line.content)}</span>
      </div>
    `;
        }
        styles() {
            return css /*css*/ `${cssContent}`;
        }
        // Event handlers
        handleKeyDown(e) {
            const input = e.target;
            switch (e.key) {
                case 'Enter':
                    e.preventDefault();
                    this.handleCommand(input.value);
                    input.value = '';
                    this.historyIndex = -1;
                    this.currentInput = '';
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    this.navigateHistory('up', input);
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    this.navigateHistory('down', input);
                    break;
                case 'Tab':
                    e.preventDefault();
                    // TODO: Add command completion
                    break;
                case 'c':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        input.value = '';
                        this.writeln('^C', 'info');
                    }
                    break;
                case 'l':
                    if (e.ctrlKey) {
                        e.preventDefault();
                        this.clear();
                    }
                    break;
            }
        }
        navigateHistory(direction, input) {
            if (this.commandHistory.length === 0)
                return;
            if (direction === 'up') {
                if (this.historyIndex === -1) {
                    this.currentInput = input.value;
                    this.historyIndex = this.commandHistory.length - 1;
                }
                else if (this.historyIndex > 0) {
                    this.historyIndex--;
                }
                input.value = this.commandHistory[this.historyIndex];
            }
            else {
                if (this.historyIndex === -1)
                    return;
                if (this.historyIndex < this.commandHistory.length - 1) {
                    this.historyIndex++;
                    input.value = this.commandHistory[this.historyIndex];
                }
                else {
                    this.historyIndex = -1;
                    input.value = this.currentInput;
                }
            }
        }
        async handleCommand(commandLine) {
            commandLine = commandLine.trim();
            if (!commandLine)
                return;
            // Add to history
            this.commandHistory.push(commandLine);
            // Write input line
            this.writeln(`${this.prompt}${commandLine}`, 'input');
            // Parse command for event
            const parts = commandLine.split(/\s+/);
            const command = parts[0];
            const args = parts.slice(1);
            // Dispatch event
            this.dispatchCommandEvent(command, args);
            // Execute command via @request
            const result = await this.executeCommand(commandLine);
            // Handle response
            if (result.output) {
                // Check for special clear marker
                if (result.output === '\x1B[CLEAR]') {
                    this.clear();
                }
                else {
                    this.writeln(result.output, 'output');
                }
            }
            if (result.error) {
                this.writeError(result.error);
            }
        }
        // ANSI color parsing. Escapes HTML first so untrusted input cannot inject
        // markup; only the ANSI escape sequences produce real <span> tags. Each SGR
        // code becomes the matching .ansi-* class, so the colour is resolved by the
        // documented --snice-terminal-ansi-* custom properties and the component's
        // own stylesheet — never a hardcoded inline literal (MATRIX-terminal-2).
        parseAnsiColors(text) {
            const ansiColorMap = {
                30: 'ansi-black',
                31: 'ansi-red',
                32: 'ansi-green',
                33: 'ansi-yellow',
                34: 'ansi-blue',
                35: 'ansi-magenta',
                36: 'ansi-cyan',
                37: 'ansi-white',
                90: 'ansi-bright-black',
                91: 'ansi-bright-red',
                92: 'ansi-bright-green',
                93: 'ansi-bright-yellow',
                94: 'ansi-bright-blue',
                95: 'ansi-bright-magenta',
                96: 'ansi-bright-cyan',
                97: 'ansi-bright-white',
            };
            const escape = (s) => s
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            // Split on ANSI escape sequences, escape text segments, pass through
            // recognized color/reset codes as <span> tags.
            const parts = [];
            const re = /\x1b\[([0-9;]+)m/g;
            let lastIndex = 0;
            let match;
            while ((match = re.exec(text)) !== null) {
                parts.push(escape(text.slice(lastIndex, match.index)));
                const codeList = match[1].split(';').map(Number);
                if (codeList.includes(0)) {
                    parts.push('</span>');
                }
                else {
                    for (const code of codeList) {
                        if (ansiColorMap[code]) {
                            parts.push(`<span class="${ansiColorMap[code]}" part="ansi">`);
                            break;
                        }
                    }
                }
                lastIndex = match.index + match[0].length;
            }
            parts.push(escape(text.slice(lastIndex)));
            return parts.join('');
        }
        // Public API
        write(content, type = 'output') {
            if (!content)
                return;
            // Parse ANSI colors
            const parsedContent = this.parseAnsiColors(content);
            const lines = parsedContent.split('\n');
            for (const line of lines) {
                this.lines.push({
                    id: crypto.randomUUID(),
                    type,
                    content: line,
                    timestamp: new Date(),
                });
            }
            this.updateLines();
        }
        writeln(content, type = 'output') {
            this.write(content, type);
        }
        writeError(content) {
            this.write(content, 'error');
        }
        clear() {
            this.lines.length = 0;
            this.liveLineBuffer = '';
            this.liveLine = null;
            this.updateLines();
            this.dispatchClearEvent();
        }
        focus() {
            this.inputElement?.focus();
        }
        writeLines(lines) {
            for (const line of lines) {
                this.lines.push({
                    id: crypto.randomUUID(),
                    type: line.type || 'output',
                    // Route through parseAnsiColors so content is HTML-escaped first
                    // (same safety path as write()); bypassing this was a stored XSS vector.
                    content: this.parseAnsiColors(line.content),
                    timestamp: new Date(),
                });
            }
            this.updateLines();
        }
        appendChunk(chunk, type = 'output') {
            if (!chunk)
                return;
            // If the type changed mid-stream, commit the existing live line first.
            if (this.liveLine && type !== this.liveLineType) {
                this.commitLiveLine();
            }
            this.liveLineType = type;
            // Combine pending tail with new chunk, then split on \n.
            const combined = this.liveLineBuffer + chunk;
            const parts = combined.split('\n');
            // Last element is whatever follows the final \n (or all of it, if no \n).
            const tail = parts.pop() ?? '';
            // Each complete part becomes its own committed line.
            for (const raw of parts) {
                const escaped = this.parseAnsiColors(raw);
                // Reuse the live line for the first complete part if present, otherwise push.
                if (this.liveLine) {
                    this.liveLine.content = escaped;
                    this.liveLine = null;
                }
                else {
                    this.lines.push({
                        id: crypto.randomUUID(),
                        type,
                        content: escaped,
                        timestamp: new Date(),
                    });
                }
            }
            // Tail (no trailing newline) keeps growing as a live line.
            this.liveLineBuffer = tail;
            if (tail) {
                const escaped = this.parseAnsiColors(tail);
                if (this.liveLine) {
                    this.liveLine.content = escaped;
                }
                else {
                    this.liveLine = {
                        id: crypto.randomUUID(),
                        type,
                        content: escaped,
                        timestamp: new Date(),
                    };
                    this.lines.push(this.liveLine);
                }
            }
            this.updateLines();
        }
        /** Force the current live (un-newlined) buffer to be treated as a finished line. */
        commitLiveLine() {
            this.liveLine = null;
            this.liveLineBuffer = '';
        }
        /**
         * Consume an AsyncIterable<string> or a ReadableStream<string|Uint8Array> until
         * exhaustion, calling appendChunk on each chunk. Cancellation: throw / return
         * from the source, or call `terminal.clear()` to stop displaying — the pipe
         * itself just runs to completion.
         */
        async pipeFrom(source, type = 'output') {
            const iter = source.getReader
                ? readableStreamToAsyncIterable(source)
                : source;
            const decoder = new TextDecoder();
            for await (const chunk of iter) {
                const text = typeof chunk === 'string' ? chunk : decoder.decode(chunk, { stream: true });
                if (text)
                    this.appendChunk(text, type);
            }
            // Flush any pending decoder state (no-op for string sources).
            const flush = decoder.decode();
            if (flush)
                this.appendChunk(flush, type);
        }
        getHistory() {
            return [...this.commandHistory];
        }
        clearHistory() {
            this.commandHistory = [];
            this.historyIndex = -1;
        }
    });
    return _classThis;
})();
/** Adapt a ReadableStream to an async iterable (Safari < 14.1 lacks the
 *  built-in `Symbol.asyncIterator` on streams). */
async function* readableStreamToAsyncIterable(stream) {
    const reader = stream.getReader();
    try {
        while (true) {
            const { value, done } = await reader.read();
            if (done)
                return;
            yield value;
        }
    }
    finally {
        reader.releaseLock();
    }
}

export { SniceTerminal };
//# sourceMappingURL=snice-terminal.js.map
